/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationSharedCourseListMultiple200,
  GetApiV1CourseregistrationSharedCourseListMultiple401,
  GetApiV1CourseregistrationSharedCourseListMultiple500,
  GetApiV1CourseregistrationSharedCourseListMultipleQueryParams,
  GetApiV1CourseregistrationSharedCourseListMultipleQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedCourseListMultiple.ts";
import { dropDownListStringKeyViewModelSchema } from "../dropDownListStringKeyViewModelSchema.ts";

export const getApiV1CourseregistrationSharedCourseListMultipleQueryParamsSchema =
  z.object({
    filter: z.optional(z.string()),
    companyId: z.optional(z.coerce.number().int()),
    includeRelationShip: z.boolean().default(false),
  }) as unknown as ToZod<GetApiV1CourseregistrationSharedCourseListMultipleQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationSharedCourseListMultiple200Schema =
  z.array(
    z.lazy(() => dropDownListStringKeyViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedCourseListMultiple200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationSharedCourseListMultiple401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedCourseListMultiple401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationSharedCourseListMultiple500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedCourseListMultiple500>;

export const getApiV1CourseregistrationSharedCourseListMultipleQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationSharedCourseListMultiple200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedCourseListMultipleQueryResponse>;
